import clsx from 'clsx';
import type { HTMLAttributes, Ref } from 'react';

import { emptyChildren } from './empty-node-children.css';

export function EmptyNodeChildren({
  ref,
  children,
  className,
  ...attrs
}: HTMLAttributes<HTMLDivElement> & { ref?: Ref<HTMLDivElement> }) {
  return (
    <div className={clsx(emptyChildren, className)} ref={ref} {...attrs}>
      {children}
    </div>
  );
}
